import { lendingAPISagaWorkers } from '@api/lendingAPI/LendingAPI.sagas';
import createSagaMiddleware from 'redux-saga';
import { all } from 'redux-saga/effects';

import { intercomSagaWorkers } from '../iwIntercom/IwIntercom.sagas';
import { iwModalsWorkers } from '../iwModals/IwModals.sagas';
import { routerSagaWorkers } from '../iwRouter/IwRouter.sagas';
import { siteContextSagaWorkers } from '../iwSiteContext/IwSiteContext.sagas';
import { threatmetrixSagasWorkers } from '../iwThreatmetrix/iwThreatmetrix.sagas';
import { mainContentSagaWorkers } from '../myAccount/pageStructure/mainContent/MainContent.sagas';
import { trackingSagaWorkers } from '../tracking/tracking.sagas';

export const sagaMiddleware = createSagaMiddleware();

export function startSagasWorkers() {
    sagaMiddleware.run(mainSagaWorker);
}

function* mainSagaWorker() {
    yield all([
        ...trackingSagaWorkers,
        ...threatmetrixSagasWorkers,
        ...intercomSagaWorkers,
        ...siteContextSagaWorkers,
        ...routerSagaWorkers,
        ...lendingAPISagaWorkers,
        ...mainContentSagaWorkers,
        ...iwModalsWorkers
    ]);
}
